import { render, staticRenderFns } from "./taskClaimAudit.vue?vue&type=template&id=ddc2caea&scoped=true&"
import script from "./taskClaimAudit.vue?vue&type=script&lang=js&"
export * from "./taskClaimAudit.vue?vue&type=script&lang=js&"
import style0 from "./taskClaimAudit.vue?vue&type=style&index=0&id=ddc2caea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc2caea",
  null
  
)

export default component.exports